module.exports = __webpack_public_path__ + "img/withdraw.61ed658f.svg";